import { BaseModel, attr, belongsTo } from "../../lib/itn-ui-kit/data";

export default class PaymentModel extends BaseModel {
  static urlPath = "payments";

  @attr("string") validFrom;
  @attr("string") validTo;
  @attr("string") paymentMethod;
  @attr("string") bankName;
  @attr("string") accountNumber;
  @attr("string") routingNumber;
  @attr("number") clientManagementSplit;
  @attr("number") providerSplit;
  @attr("number") marketingSplit;
  @attr("boolean") reviewContract;
  @attr("number") entity;
  @belongsTo("address") billingAddress;
  @belongsTo("address") mailingAddress;
}
